"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var Label_1 = require("../Label/Label");
var styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
var FormGroupContext_1 = tslib_1.__importDefault(require("./FormGroupContext"));
var uniqueId = require('lodash.uniqueid');
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-bottom: ", ";\n  > ", " {\n    margin-bottom: ", ";\n  }\n"], ["\n  margin-bottom: ", ";\n  > ", " {\n    margin-bottom: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.formGroup.bottomMargin);
}, Label_1.Wrapper, function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.formGroup.labelGutter);
});
var FormGroup = /** @class */ (function (_super) {
    tslib_1.__extends(FormGroup, _super);
    function FormGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            id: uniqueId(),
        };
        return _this;
    }
    FormGroup.prototype.render = function () {
        var children = this.props.children;
        return (React.createElement(FormGroupContext_1.default.Provider, { value: this.state },
            React.createElement(Wrapper, null, children)));
    };
    return FormGroup;
}(React.PureComponent));
exports.default = FormGroup;
var templateObject_1;
